export const COMMON_ID: number = 1;
